import "./Login.css";

import * as animationData from "../../../assets/animations/login-anim-temp.json";

import {
  setForgotPasswordVisible,
  setLoginVisible,
} from "../../../store/modals/modalActions";
import { useAppDispatch, useAppSelector } from "../../../hooks/reduxHooks";
import { useEffect, useState } from "react";

import CustomInput from "../../CustomInput/CustomInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Lottie from "react-lottie";
import Modal from "react-modal";
import ReactLoading from "react-loading";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { login } from "../../../api/auth";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string[]>([]);
  const infringement = useAppSelector((state) => state.fine.infringement);
  const user = useAppSelector((state) => state.auth.user);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  useEffect(() => {
    applyOverlay();
    return () => removeOverlay();
  }, []);

  const applyOverlay = () => {
    document.getElementById("App")!.style.opacity = "0.5";
    document.getElementById("App")!.style.overflowY = "hidden";
  };
  const removeOverlay = () => {
    document.getElementById("App")!.style.opacity = "1";
    document.getElementById("App")!.style.overflowY = "visible";
  };

  const onCloseClicked = () => {
    dispatch(setLoginVisible(false));
  };

  const onLoginClicked = async () => {
    if (!email.trim()) {
      document.getElementById("email-input")!.style.border = "1px solid red";
      setError((error: any) => [...error, "Please enter an email"]);
    } else {
      document.getElementById("email-input")!.style.border =
        "1px solid #d7d7d7";
    }
    if (!password.trim()) {
      document.getElementById("password-input")!.style.border = "1px solid red";
      setError((error: any) => [...error, "Please enter a password"]);
    } else {
      document.getElementById("password-input")!.style.border =
        "1px solid black";
    }
    if (email && password) {
      setError([]);
      setLoading(true);
      login(email, password.trim()).then(async (response: any) => {
        const { loginError } = response;
        setLoading(false);
        if (!loginError) {
          dispatch(setLoginVisible(false));
        } else {
          setError((errors) => [...errors, loginError]);
        }
      });
    }
  };

  const onRegisterClicked = () => {
    navigate("/register");
  };

  const onForgotPasswordClicked = () => {
    dispatch(setLoginVisible(false));
    dispatch(setForgotPasswordVisible(true));
  };

  const modalStyle = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      overflow: "hidden",
    },
  };

  return (
    <Modal isOpen={true} style={modalStyle} ariaHideApp={false}>
      <div className="login-header">
        <p className="login-heading">
          Login is currently required for fines with a warrant status
        </p>

        <FontAwesomeIcon
          className="close-icon"
          icon={faClose}
          size="1x"
          color="#18283c"
          onClick={() => onCloseClicked()}
        />
      </div>
      <div className="login-section-container">
        <div className="login-section">
          <p className="login-title">Login</p>

          <CustomInput
            label="Email Address"
            id="email-input"
            type="email"
            value={email}
            setValue={setEmail}
            placeholder="Email Address"
            containerStyle={{
              width: window.innerWidth > 480 ? "82%" : "100%",
              marginLeft: window.innerWidth > 480 ? "-10%" : 0,
            }}
          />

          <CustomInput
            label="Password"
            id="password-input"
            setValue={setPassword}
            placeholder="Password"
            type="password"
            containerStyle={{
              width: window.innerWidth > 480 ? "82%" : "100%",
              marginLeft: window.innerWidth > 480 ? "-10%" : 0,
            }}
            onKeyPress={(event) => {
              if (event.key === "Enter" && !loading) {
                onLoginClicked();
              }
            }}
            error={error[0]}
          />
          <p
            className="forgot-password"
            onClick={() => onForgotPasswordClicked()}
          >
            Forgot Password
          </p>

          <div className="login-button-modal" onClick={() => onLoginClicked()}>
            {!loading ? (
              <p>Login</p>
            ) : (
              <ReactLoading type="bubbles" color="white" />
            )}
          </div>
          <span className="register-text">
            Don’t have a Pay@ account? &nbsp;
            <p
              style={{
                textDecoration: "underline",
                fontWeight: "bold",
                cursor: "pointer",
              }}
              onClick={() => onRegisterClicked()}
            >
              Register Now
            </p>
          </span>
        </div>
        <div className="login-image">
          <Lottie
            options={defaultOptions}
            height={500}
            width={500}
            isStopped={false}
            isPaused={false}
          />
        </div>
      </div>
    </Modal>
  );
};

export default Login;
